export default "__VITE_ASSET__CSykAws4__"